// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"Results_buttonContainer__14row"};